import { render, staticRenderFns } from "./practiceTrainingTask.vue?vue&type=template&id=79445376&scoped=true"
import script from "./practiceTrainingTask.vue?vue&type=script&lang=js"
export * from "./practiceTrainingTask.vue?vue&type=script&lang=js"
import style0 from "./practiceTrainingTask.vue?vue&type=style&index=0&id=79445376&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79445376",
  null
  
)

export default component.exports